const PageTitle = ({ title, count = 0, showCount = true }) => {
    return (
        <div
            style={{
                fontFamily: 'SamsungOne-800',
                fontSize: '24px',
                marginBottom: '0.8rem',
            }}
        >
            {title} {showCount && `(${count})`}
        </div>
    );
};

export default PageTitle;
